export default "__VITE_ASSET__DlkuB3p3__"